import { useQuery } from '@tanstack/react-query'
import { getChannelCohortAnalytics } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import type { GetChannelCohortAnalyticsResponse } from '@/modules/dashboard/type'

export const useQueryGetChannelCohortAnalytics = (channelId: string) => {
	return useQuery<GetChannelCohortAnalyticsResponse>({
		queryKey: [DashboardKeys.ChannelCohortAnalytics, channelId],
		queryFn: () => getChannelCohortAnalytics(channelId),
		enabled: !!channelId,
	})
}

export default useQueryGetChannelCohortAnalytics
